import _ from "lodash";
import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class LineItemDataStore extends EventEmitter {
	constructor() {
		super();

		this.lineitems = {
			data: [],
			config: [],
			errors: [],
			filteredData: [],
			filterIO: null,
			filterIOID: null
		};

		/*
		Need to register all actions with the AppDispatcher
		*/

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchLineItems:
					const hierarchyData = action.value.data;
					hierarchyData.forEach((dataField) => {
						if (dataField.TaxonomyData) {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.TaxonomyData.forEach((configTaxonomyField) => {
										if (
											configTaxonomyField.ID === dataTaxonomyField.DataKeyID &&
											configTaxonomyField.Name !== dataTaxonomyField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configTaxonomyField.Name] = dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
						if (dataField.MetaData) {
							JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
								if (dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.MetaData.forEach((configMetaDataField) => {
										if (
											configMetaDataField.ID === dataMetaDataField.DataKeyID &&
											configMetaDataField.Name !== dataMetaDataField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configMetaDataField.Name] = dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
					});
					this.lineitems.config = action.value.config;
					this.lineitems.data = hierarchyData;
					this.emit("lineitems_loaded");
					break;
				case AppActionConstants.fetchOnlyLineItems:
					const onlyLIConfig = this.lineitems.config;
					const onlyLIData = this.updateExistingValues(action.value, onlyLIConfig);
					this.lineitems.data = onlyLIData;
					this.emit("only_LI_fetched");
					break;
				case AppActionConstants.fetchOnlyLineItemsConfig:
					this.lineitems.config = action.value;
					this.emit("only_LI_config_fetched");
					break;
				case AppActionConstants.setFilteredLineItems:
					this.lineitems.filteredData = action.value;
					this.emit("filteredData");
					break;
				case AppActionConstants.createLineItemSuccess:
					this.lineitems.data = [...this.lineitems.data, action.value];
					this.emit("lineitems_success");
					break;
				case AppActionConstants.createLineItemFail:
					const errorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								errorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						errorObject.Errors = [action.value.Errors];
					}
					this.lineitems.errors = errorObject;
					this.emit("lineitems_fail");
					break;
				case AppActionConstants.editLineItemSuccess:
					this.lineitems.data.splice(action.row, 1, action.value);
					this.lineitems.data = [...this.lineitems.data];
					this.emit("lineitems_edit_success");
					break;
				case AppActionConstants.editLineItemFail:
					const editErrorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								editErrorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						editErrorObject.Errors = [action.value.Errors];
					}
					this.lineitems.errors = editErrorObject;
					this.emit("lineitems_edit_fail");
					break;
				case AppActionConstants.createAndAddLineItemSuccess:
					this.lineitems.data = [...this.lineitems.data, action.value];
					this.emit("create_and_add_lineitems_success");
					break;
				case AppActionConstants.deleteLineItem:
					this.lineitems.data = this.lineitems.data.filter((lineitem) => {
						return !action.value.includes(lineitem.LineItemID);
					});
					if (this.lineitems.filteredData.length !== 0) {
						const filteredData = JSON.parse(JSON.stringify(this.lineitems.filteredData));
						this.lineitems.filteredData = filteredData.filter((filteredLI) => {
							return !action.value.includes(filteredLI.LineItemID);
						});
					}
					this.emit("lineitem_deleted");
					break;
				case AppActionConstants.duplicateLineItem:
					this.emit("duplicate_lineitem_success");
					break;
				case AppActionConstants.duplicateLineItemFail:
					this.emit("duplicate_lineitem_fail");
					break;
				case AppActionConstants.setFilterIO:
					this.lineitems.filterIO = action.value[0];
					this.lineitems.filterIOID = action.value[1];
					let data = JSON.parse(JSON.stringify(this.getData()));
					data = data.filter((lineItem) => {
						return lineItem.InsertionOrderID === action.value[1];
					});
					this.lineitems.filteredData = data;
					this.emit("filtered_IO");
					break;
				case AppActionConstants.deleteChildLineItems:
					const lineItemsDeleted = this.lineitems.data.filter((lineitem) => lineitem.InsertionOrderID === action.value).length;
					if (lineItemsDeleted) {
						this.lineitems.data = this.lineitems.data.filter((lineitem) => {
							return lineitem.InsertionOrderID !== action.value;
						});
						if (this.lineitems.filteredData.length !== 0) {
							const filteredData = JSON.parse(JSON.stringify(this.lineitems.filteredData));
							this.lineitems.filteredData = filteredData.filter((filteredLI) => {
								return filteredLI.InsertionOrderID !== action.value;
							});
						}
						this.emit("lineitem_deleted");
					}
					break;
				case AppActionConstants.triggerLineItemModal:
					this.emit("openLineItemModal");
					break;
				case AppActionConstants.childLineItemsSuccess:
					const duplicatedChildData = this.updateExistingValues(action.value.data, action.value.config);
					this.lineitems.data = duplicatedChildData;
					this.emit("child_lineitems_created");
					break;
				case AppActionConstants.childLineItemsFail:
					this.emit("child_lineitems_failed");
					break;
				case AppActionConstants.updateLineItemsSyncStatus:
					this.lineitems.data.forEach((lineItem) => {
						if (action.value.includes(lineItem.LineItemID)) {
							lineItem.ExternalSystemStatusID = "4";
							lineItem.ExternalSystemResponse = "Sent to Queue";
						}
					});
					this.emit("sync_status_updated");
					break;
				default:
					break;
			}
		});
	}

	/*
	Getter function to return the current state
	*/
	getData = () => this.lineitems.data;
	getConfig = () => this.lineitems.config;
	getErrors = () => this.lineitems.errors;
	getFilterIO = () => this.lineitems.filterIO;
	getFilterIOID = () => this.lineitems.filterIOID;
	getFilteredData = () => this.lineitems.filteredData;

	updateFilteredData = (newFilteredData) => {
		this.lineitems.filteredData = newFilteredData;
	};

	resetSelectedIO = () => {
		this.lineitems.filterIO = null;
	};

	resetSelectedIOID = () => {
		this.lineitems.filterIOID = null;
	};

	returnFilteredDataRow = (row) => {
		return this.lineitems.filteredData[row];
	};

	resetLineItemErrors = () => {
		this.lineitems.errors = [];
		this.emit("lineitems__errors__reset");
	};

	resetLineItemData = () => {
		this.lineitems.config = [];
	};

	returnDataRow = (row) => {
		return this.lineitems.data[row];
	};

	updateDataManually = (data, bundle) => {
		for (const key in bundle) {
			if (bundle[key].Result === true) {
				const newRow = this.getFilteredData().length !== 0 ? this.returnFilteredDataRow(key) : this.returnDataRow(key);
				if (newRow) {
					newRow.LineItemName = bundle[`${key}`].Object.LineItemName;
					newRow.UniqueID = bundle[`${key}`].Object.UniqueID;
					if (bundle[`${key}`].Object.ParentUniqueIDCode) {
						newRow.ParentUniqueIDCode = bundle[`${key}`].Object.ParentUniqueIDCode;
					}
					newRow.LineItemID = bundle[`${key}`].Object.LineItemID;
				} else {
					const existingRow = data.filter((lineItem) => lineItem.UniqueID === key);
					if (existingRow[0]) {
						existingRow[0].UniqueID = bundle[`${key}`].Object.UniqueID;
						existingRow[0].LineItemName = bundle[`${key}`].Object.LineItemName;
					}
				}
			}
		}
	};

	updateExistingValues = (data, config) => {
		const newData = data;
		const fieldNames = {};
		const fieldIds = {};
		const excludedFieldNames = ["CampaignID", "UniqueID", "TaxonomyData", "MetaData", "LineItemName", "LineItemID", "IsArchived", "IsDeleted", "UpdatedBy"];
		config.TaxonomyData.forEach((taxonomyField) => {
			fieldNames[taxonomyField.Name] = taxonomyField.ID;
			fieldIds[taxonomyField.ID] = taxonomyField.Name;
		});
		config.MetaData.forEach((metadataField) => {
			fieldNames[metadataField.Name] = metadataField.ID;
			fieldIds[metadataField.ID] = metadataField.Name;
		});
		config.LineItemData.forEach((placementField) => {
			fieldNames[placementField.Name] = placementField.ID;
			fieldIds[placementField.ID] = placementField.Name;
		});
		newData.forEach((dataField) => {
			if (!_.isEmpty(dataField)) {
				Object.keys(dataField).forEach((dataKeyName) => {
					if (!excludedFieldNames.includes(dataKeyName) && !Object.keys(fieldNames).includes(dataKeyName)) {
						let matchingId = null;
						if (dataField.TaxonomyData !== "") {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (matchingId !== null) {
									return;
								}
								if (dataTaxonomyField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
									matchingId = dataTaxonomyField.DataKeyID;
								}
							});
						}
						if (matchingId === null) {
							if (dataField.MetaData !== "") {
								JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
									if (matchingId !== null) {
										return;
									}
									if (dataMetaDataField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
										matchingId = dataMetaDataField.DataKeyID;
									}
								});
							}
						}
						if (matchingId !== null) {
							if (fieldIds[matchingId]) {
								dataField[fieldIds[matchingId]] = dataField[dataKeyName];
							}
						}
					}
				});
			}
		});
		return newData;
	};
}

export default new LineItemDataStore();
